




























import { computed, defineComponent } from '@vue/composition-api';
import { SettingsService } from '@/services/storageService';

export default defineComponent({
	setup() {
		const distanceUnit = computed<string>({
			get: () => SettingsService.getDistanceUnit(),
			set: SettingsService.setDistanceUnit,
		});
		const hideLocationNumber = computed<boolean>({
			get: () => SettingsService.getHideLocationNumber(),
			set: SettingsService.setHideLocationNumber,
		});

		return {
			distanceUnit,
			hideLocationNumber,
		};
	},
});
